import React, { useState, useEffect } from 'react';

function ErrorBoundary({ children }) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const errorHandler = (error, errorInfo) => {
      // Todo : log the error to an error reporting service here
      console.error('Error:', error);
      console.error('Error Info:', errorInfo);
      setHasError(true);
    };

    window.addEventListener('error', errorHandler);

    return () => {
      window.removeEventListener('error', errorHandler);
    };
  }, []);

  if (hasError) {
    //Todo Render a fallback UI when an error occurs
    return <div className="view-issue-page">Something went wrong.</div>;
  }

  return children;
}

export default ErrorBoundary;
